import { useEffect, useState } from "react";

// On phones, pin dialogs to the *visual* viewport so the iOS keyboard/browser chrome can't push them off-screen.
export function useVisualViewportStyle(full) {
  const [style, setStyle] = useState(undefined);
  useEffect(() => {
    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    if (!vv) return undefined;
    const upd = () => {
      if (window.innerWidth >= 640) { setStyle(undefined); return; }
      setStyle(full
        ? { top: vv.offsetTop, left: 0, transform: "none", width: "100%", height: vv.height, maxHeight: vv.height }
        : { top: vv.offsetTop + 12, maxHeight: vv.height - 24 });
    };
    upd();
    vv.addEventListener("resize", upd);
    vv.addEventListener("scroll", upd);
    return () => { vv.removeEventListener("resize", upd); vv.removeEventListener("scroll", upd); };
  }, [full]);
  return style;
}

export const keepFocusedVisible = (e) => {
  const el = e.target;
  if (!el?.matches?.("input, textarea, select") || window.innerWidth >= 640) return;
  setTimeout(() => el.scrollIntoView({ block: "center", behavior: "smooth" }), 300);
};
